import type {
  AssistedFamilyRegistrationInput,
  FamilyApplication,
  FamilyChild,
  FamilyRegistrationInput,
} from '../types/domain'
import { apiJson } from './api'
import { ApiError } from './apiError'

export class FamilyRegistrationApiError extends Error {
  public readonly code: string
  constructor(message: string, code: string) {
    super(message)
    this.name = 'FamilyRegistrationApiError'
    this.code = code
  }
}

async function parseResponse<T>(work: Promise<unknown>, fallback: string): Promise<T> {
  try {
    return (await work) as T
  } catch (cause) {
    if (!(cause instanceof ApiError)) throw cause
    throw new FamilyRegistrationApiError(cause.message || fallback, cause.code)
  }
}

export async function registerOwnedFamily(
  _ownerUserId: string,
  input: FamilyRegistrationInput,
): Promise<FamilyApplication> {
  return parseResponse(apiJson('/spmb/family/registrations', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
    'Pendaftaran belum dapat disimpan.',
  )
}

export async function registerAssistedFamily(
  input: AssistedFamilyRegistrationInput,
): Promise<FamilyApplication> {
  return parseResponse(apiJson('/spmb/family/assisted-registrations', {
      method: 'POST',
      body: JSON.stringify(input),
    }),
    'Pendaftaran berbantuan belum dapat disimpan.',
  )
}

export async function getOwnedFamilyChildren(
  _ownerUserId?: string,
): Promise<FamilyChild[]> {
  return parseResponse(apiJson('/spmb/family/children'),
    'Data anak dan pendaftaran belum dapat dimuat.',
  )
}

export async function getAssistedFamilyApplication(
  applicationId: string,
): Promise<FamilyApplication> {
  return parseResponse(apiJson(
      `/spmb/family/assisted-applications/${encodeURIComponent(applicationId)}`,
    ),
    'Draft tidak ditemukan atau tidak berada dalam scope layanan Anda.',
  )
}
